export const images = [
    {
      id: '01',
      src: '/At Home Rexburg 01.jpg',
      alt: 'Lofts on 34th',
    },
    // {
    //   id: '02',
    //   src: '/shulsen-lane-2.jpg',
    //   alt: 'Shulsen Lane',
    // },
    {
      id: '03',
      src: '/At Home Rexburg 02.jpg',
      alt: 'Lofts on 34th',
    },
    {
      id: '04',
      src: '/At Home Rexburg 04.jpg',
      alt: 'Lofts on 34th',
    },
    
    {
        id: '06',
        src: '/At Home Rexburg 05.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/At Home Rexburg 06.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/At Home Rexburg 07.jpg',
        alt: 'Lofts on 34th',
      },
    //   {
    //     id: '05',
    //     src: '/DesertSage (5).jpg',
    //     alt: 'Shulsen Lane',
    //   },
    // {
    //   id: '06',
    //   src: '/Alpine_Flats_Theater_Room.jpg',
    //   alt: 'Revive Apartments',
    // },
   
  ]